<template>
  <v-dialog v-model="dialog" max-width="700">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Imposta Setpoint Termostato
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="6">
            <v-form ref="form" v-model="valid">
              <div class="slider-wrapper mt-8">
                <circular-temperature-slider
                  v-model="setpoint"
                  :min="2.5"
                  :max="20"
                  :step="0.5"
                  :size="260"
                  @change="validateSetpoint"
                  label="Setpoint"
                />
              </div>
            </v-form>
          </v-col>
          <v-col cols="6">
            <v-form ref="formAlarm" v-model="valid">
              <div class="slider-wrapper mt-8">
                <circular-temperature-slider
                  v-model="alarmPoint"
                  :min="0"
                  :max="setpoint - 2"
                  :step="0.5"
                  :size="260"
                  @change="validateAlarmPoint"
                  label="Punto Allarme"
                  monotonic
                />
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-8">
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="dialog = false">Annulla</v-btn>
        <v-btn
          outlined
          color="primary"
          @click="submitSetpoint"
          >Salva</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import setpointbox_mixin from "../mixin/therm_setpoint_box_mixin.js";
export default {
  components: {
    CircularTemperatureSlider: () => import("./CircularTemperatureSlider.vue"),
  },
  mixins: [setpointbox_mixin],
};
</script>

<style scoped>
.v-card-title {
  justify-content: center;
}
.slider-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.helper {
  margin-top: 12px;
  font-weight: 500;
  color: #1976d2;
}
.error-msg {
  margin-top: 6px;
  color: #d32f2f;
  font-size: 13px;
}
</style>